import React from 'react';  // import the React library
import './App.css'; // import your CSS file
import Routes from './routes';


class App extends React.Component {
render() {  
  return (
    <div>
<Routes />
</div>
    );
  }

}
  
export default App;
